import type { Arbetsblad } from '../types'
import SvarsutrymmeVy from './SvarsutrymmeVy'

/** Arbetsbladet som färdigt, utskrivbart material: rubrik, ev. instruktion och
 *  numrerade uppgifter med sina definierade svarsutrymmen. Samma komponent
 *  används som förhandsvisning på lektionssidan och i fokusutskriften, så det
 *  läraren ser är det som skrivs ut. Uppgiftstexterna är klartext (radbrytningar
 *  bevaras); referens-fältet är ren data och visas aldrig. */
export default function ArbetsbladVy({ arbetsblad, medNamnrad }: { arbetsblad: Arbetsblad; medNamnrad?: boolean }) {
  return (
    <div className="arbetsblad-vy">
      {arbetsblad.rubrik && <h1 className="arbetsblad-rubrik">{arbetsblad.rubrik}</h1>}
      {medNamnrad && <p className="arbetsblad-namnrad">Namn: _______________________ Klass: _________ Datum: _________</p>}
      {arbetsblad.instruktion && <p className="arbetsblad-instruktion">{arbetsblad.instruktion}</p>}
      <ol className="arbetsblad-uppgifter">
        {arbetsblad.uppgifter.map((uppgift) => (
          <li key={uppgift.nummer} value={uppgift.nummer} className="arbetsblad-uppgift">
            <p className="uppgift-text">{uppgift.text}</p>
            <SvarsutrymmeVy svarsutrymme={uppgift.svarsutrymme} />
          </li>
        ))}
      </ol>
    </div>
  )
}
